<template>
  <div id="app">
    <div class="wrapper">
      <navigation></navigation>
      <div class="inner-content">
        <router-view></router-view>
      </div>
      <footer-view></footer-view>
    </div>

  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import FooterView from '@/components/FooterView'

export default {
  name: 'app',
  components:{
    Navigation,
    FooterView
  }
}
</script>

<style>
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>



// WEBPACK FOOTER //
// App.vue?47e3515c